const json = `
<p>我们的隐私政策已于 2025年 11月 7 日更新。 请花一些时间熟悉我们的隐私政策，如果您有任何问题，请联系我们。</p>
<p class="subTitle">引言</p>
<p>wi6te是由钱柜物联公司及其关联公司（以下简称“钱柜”或“我们”）为您提供中继器管理、联网设备管理、Wi-Fi管理等服务的应用。</p>
<p>本隐私政策在制定时充分考虑到您的需求，您全面了解我们的个人信息收集和使用惯例，同时确保您最终能控制提供给我们的个人信息，这一点至关重要。本隐私政策规定我们如何收集、使用、披露、处理和存储您使用我们的wi6te时提供给我们的信息。本隐私政策下“个人信息”指通过信息本身或通过关联其他信息后能够识别特定个人的数据。我们将严格遵守本隐私政策来使用这些信息。</p>
<p class="subTitle">一、我们收集哪些信息以及如何使用信息</p>
<p class="sub">（一）您须授权我们收集和使用您个人信息的情形</p>
<p>收集个人信息的目的在于向您提供产品和/或服务，并且保证我们遵守适用的相关法律、法规及其他规范性文件。您有权自行选择是否提供该信息，但多数情况下，如果您不提供，我们可能无法向您提供相应的服务，也无法回应您遇到的问题。这些功能包括：</p>
<p>1. 实现管理、控制中继器所必须的功能</p>
<p>（1） 配置中继器</p>
<p>为了配置中继器，为您提供wi6te的服务，我们可能会收集您的位置信息、设备和账号的绑定关系、设备标识信息、配置的中继器信息以及硬件与系统信息。其中，您的位置信息用来获取Wi-Fi列表（Android6.0版本及以上，需要位置权限才能获取Wi-Fi列表和蓝牙使用权限）以判断设备连接服务器，判断默认语言。配置的中继器信息将用于确认设备类型、激活、活跃状态，判断初始化过程中包含的软件功能，以及识别SSID，用于和设备进行绑定。我们也会为了不断改进和优化上述的功能来使用您的上述个人信息。</p>
<p>上述各类信息，详细列举如下：</p>
<p>● 设备标识信息：MAC地址，Android ID、IP，IMEI，IMSI。</p>
<p>● 配置的中继器信息：与您的中继器相关的信息。包括中继器激活状态、绑定状态、活跃状态、分享状态、型号、系统版本号、MAC地址、设备序列号、设备ID、国家码及中继器使用位置。</p>
<p>● 硬件与系统信息：面板指示灯开关状态、USB3.0开关状态、默认时区、默认日期、默认时间、固件版本号、默认语言。</p>
<p>（2） 识别和展示已连接中继器的设备</p>
<p>为了提供管理中继器的功能，我们有可能收集包括网络信息、终端设备信息、位置信息以及硬盘信息在内的任一或所有信息。中继器相关信息用于识别设备，为每一台设备提供相应的功能及流程，例如根据激活状态确认是否进入初始化流程、根据绑定状态确认是否可绑定、根据国家码确认默认时间及语言、根据系统版本号提供对应的功能，同时该部分数据还会被用于中继器本地的管理及wi6te的应用内展示，供您管理网络所用。网络信息中的网络SSID以及非明文密码，以及硬盘信息中的索引信息将被我们用于为您提供远程访问服务。远程访问时相关的数据只会经由我们的服务器下发到您的终端设备上，我们并不会存储此部分数据。</p>
<p>上述各类信息，详细列举如下：</p>
<p>● 网络信息：与网络状况相关的信息。包括网络SSID、上网模式、网关地址、WAN口上下行速率、加密模式、WiFi信道、非明文密码、MU-MIMO开关状态、场景优化开关状态、2.4G/5G频段开关状态及VPN配置信息（如果用户有配置过相关信息）。</p>
<p>● 终端设备信息：连入网络的终端设备相关信息。包括设备上下线行为及时间、设备名称、IP地址、MAC地址、设备类型、设备品牌、设备型号、连接类型、信号强度、噪音强度、上下行速率及流量、最大上下行速率、访客无线网络标识信息、访客网络接入及离开时间、操作系统、设备在线时间、连入网络行为计数，同时当设备占用带宽大于给定的阈值时，会上报带宽占用比例及持续时间。</p>
<p>● 位置信息：与位置相关的信息。包括国家码、GPS定位（如获得权限）、默认时区、默认日期、默认时间及默认语言。</p>
<p>● 硬盘信息：如果您在中继器上外接了硬盘，或者自带硬盘，我们还会收集与硬盘有关的信息。包括存储的文件概况，具体为总体的大小、计数及索引信息。如果您开通了手机相册备份功能（详见下），我们还可能收集您备份照片文件概况，具体为总体的大小、计数和索引信息。</p>
<p>（3） 提供推送功能</p>
<p>为了提供中继器的推送功能，我们可能会收集终端设备信息、磁盘信息以及网络信息，为您提供消息推送服务。推送内容包括终端设备上线提醒、新版本升级提醒、备份行为提醒、信道切换提醒、权限分享提醒、系统错误提醒、设备报告提醒以及功能推荐提醒。</p>
<p>（4） 应用升级功能</p>
<p>为了使您持续享受wi6te的服务，我们会为您提供应用升级的功能。此功能中，我们可能收集中继器名称以及系统版本信息，用于为您展示设备的版本信息和升级功能。</p>
<p class="sub">（二）您可选择授权我们收集和使用您的个人信息的情形</p>
<p>（1） 防蹭网设置</p>
<p>我们可以为您提供防蹭网设置的功能，为了使用此功能，我们可能会收集您设置的防蹭网等级、联网黑名单&白名单，以及已拦截和接入失败的设备MAC地址，用于展示防蹭网效果，实现防蹭网功能。请您放心，这些信息存储在中继器本地，不会存储至云端。</p>
<p>（2） Wi-Fi测速和优化：</p>
<p>我们会读取下载速度、上传速度、网络延迟、手机网络安全状态、Wi-Fi信道情况、噪音强度、信道吞吐量、下载任务状态、传输状态、信号强度信息。这些信息将用于为您评估和展示Wi-Fi质量、下载状态、传输状态、信号强度。请您放心，这些信息均为本地读取，不会存储至云端。</p>
<p>（3） 智能限速：</p>
<p>我们提供智能限速功能，当您开启智能限速功能时，我们可能收集带宽信息、上下行速率、您设置的限速类型（例如游戏优先）、您设置的上下行限速信息。这些信息将用于智能分配网速和限速。</p>
<p>（4） 分享中继器的功能：</p>
<p>当开启此功能时，我们将收集您中继器的分享状态和分享的账户信息，用户为您提供分享的功能，同时您也可以控制您的分享，以及查看中继器的分享状态。</p>
<p>（5） 用户反馈：</p>
<p>我们可能收集您发给我们的反馈的问题、反馈截图（选填）、您提供的手机号或邮箱（选填）、APP日志、中继器日志（选填），用于让我们更好的了解您遇到的问题，以更快的为您分析解决。</p>
<p class="sub">（三）您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的同意：</p>
<p>1、与个人信息控制者履行法律法规规定的义务相关的；</p>
<p>2、与国家安全、国防安全有关的；</p>
<p>3、与公共安全、公共卫生、重大公共利益有关的；</p>
<p>4、与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
<p>5、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</p>
<p>6、所涉及的个人信息是个人信息主体自行向社会公众公开的；</p>
<p>7、根据个人信息主体要求签订和履行合同所必需的；</p>
<p>8、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
<p>9、维护所提供产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障；</p>
<p>10、个人信息控制者为新闻单位，且其开展合法的新闻报道所必需的；</p>
<p>11、个人信息控制者为学术研究机构，出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的。</p>
<p class="sub">（四）非个人信息</p>
<p>我们还可能收集其他无法识别到特定个人的信息（即不属于个人信息的信息），例如您使用特定服务时产生的统计类数据，如设备相关信息、功能模块点击、推送展示或点击。收集此类信息的目的在于改善我们向您提供的服务。所收集信息的类别和数量取决于您如何使用我们产品和/或服务。</p>
<p>就本隐私政策而言，汇总数据被视为非个人信息。如果我们将非个人信息与个人信息结合使用，则在结合使用期间，此类信息将被视为个人信息。</p>
<p class="subTitle">二、与第三方服务提供商共享您的个人信息</p>
<p>本业务中部分服务内容由第三方服务提供商提供，为此我们需要向第三方服务提供商提供您的部分个人信息，<a target="_blank" type="text/vue" style="font-weight: bold;" href="#/sdk">点击查看</a>我们向关联方、合作伙伴及第三方共享您的个人信息的情形。如我们与这些第三方分享您的个人信息，我们将采取加密等手段保障您的信息安全。对我们与之共享个人信息的公司、组织，我们会对其数据安全环境进行合理审查，并与其签署严格的数据处理协议，要求第三方对您的信息采取足够的保护措施，严格遵守相关法律法规与监管要求。</p>
<p class="subTitle">三、保留政策</p>
<p>我们基于本隐私政策中所述的信息收集的目的所必需的期间，或者遵守适用的相关法律要求保留个人信息。个人信息在完成收集目的，或在我们确认您的删除或注销申请后，或我们终止运营相应产品或服务后，我们将停止保留，并做删除或匿名化处理。如果是出于公众利益、科学、历史研究或统计的目的，我们将基于适用的法律继续保留相关数据，即使进一步的数据处理与原有的收集目的无关。</p>
<p class="subTitle">四、您的权利</p>
<p class="sub">（一）控制设置</p>
<p>我们承认每个人对隐私权的关注各不相同。因此，我们提供了一些示例，说明wi6te提供的各种方式，供您选择，以限制收集、使用、披露或处理您的个人信息，并控制您的隐私权设置：</p>
<p>● 打开或者关闭位置访问、相机权限、读取通讯录、访问手机账户、读写手机存储和读取应用列表等权限；</p>
<p>● 打开或者关闭用户体验改善计划；</p>
<p>● 绑定或解绑wi6te中继器；</p>
<p>● 打开或关闭手机相册自动备份功能。</p>
<p>如果您之前因为上述目的同意我们使用您的个人信息，您可以随时通过书面或者向 https://naxclow@163.com发送邮件的方式联系我们来改变您的决定。</p>
<p class="sub">（二）您对您的个人信息享有的权利</p>
<p>根据您所适用的国家或地区法律法规，您有权要求访问、更正、删除我们持有的与您相关的任何个人信息（以下简称请求）。</p>
<p>大多数法律要求个人信息主体提出的请求应遵循特定要求，本隐私政策要求您的请求应当符合以下情形：</p>
<p>● 通过我们专门的请求渠道，并且出于保护您的信息安全的考虑，您的请求应当是书面的（除非当地法律明确承认口头申请）；</p>
<p>● 提供足够的信息使我们可以验证您的身份，确保请求人是所请求信息主体本人或合法授权人；</p>
<p>一旦我们获得充分信息确认可处理您的请求时，我们将在适用数据保护法律规定的时间内对您的请求做出回应。具体而言：</p>
<p>● 基于您的要求及适用法律规定，我们可免费提供一份我们已收集并处理的关于您的个人信息记录， 如您提出对于相关信息的其他请求，我们可能会基于相关适用法律，并结合实际的管理成本向您收取一笔合理的费用。</p>
<p>● 如果您认为我们持有的关于您的任何信息是不正确或不完整的，可要求基于使用目的更正或完善个人信息。</p>
<p>● 根据您适用的法律法规，您可能有权要求我们删除您的个人数据。我们将会根据您的删除请求进行评估，若满足相应规定，我们将会采取包括技术手段在内的相应步骤进行处理。当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。例如，根据《中华人民共和国电子商务法》，您的商品和服务信息、交易信息保存时间自交易完成之日起不得少于三年。</p>
<p>我们有权拒绝处理无实质意义/纠缠式重复的请求、损害他人隐私权的请求、极端不现实的请求，要求不相称的技术工作，以及根据当地法律无需给予的请求，已经公之于众的信息，保密条件下给出的信息。如果我们认为删除数据或访问数据的请求的某些方面可能会导致我们无法出于前述反欺诈和安全目的合法使用数据，可能也会予以拒绝。</p>
<p class="sub">（三）撤销同意</p>
<p>● 您可以通过应用内“路由设置>用户协议&隐私协议”完成撤销同意，包括收集、使用和/或披露我们掌握或控制的您的个人信息。我们将会在您做出请求后的合理时间内处理您的请求，并且会根据您的请求，在此后不再收集、使用和/或披露您的个人信息。</p>
<p>● 请注意，您撤销同意会导致某些法律后果。根据您授权我们处理信息的范围，这可能导致您不能享受钱柜的产品或服务。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
<p class="subTitle">五、联系我们</p>
<p>如果您对本隐私政策有任何意见或问题，或者您对我们收集、使用或披露您的个人信息有任何问题，请通过下方地址联系我们，并提及“隐私政策”。针对您关于个人信息相关的权利请求、问题咨询等时，我们有专业的团队解决你的问题。如果你的问题本身涉及比较重大的事项，我们可能会要求你提供更多信息。如果您对收到的答复不满意，您可以将投诉移交给所在司法辖区的相关监管机构。如果您咨询我们，我们会根据您的实际情况，提供可能适用的相关投诉途径的信息。</p>
<p>联系地址：</p>
<p>广州市南沙区南沙街道华汇国际广场918</p>
<p>邮政编码 511466</p>
`

export default json
